import React from "react";

const FortellisSubtitle2 = ({ subtitle }) => {
  return <div className="fortellis-subtitle-2">{subtitle}</div>;
};

export default FortellisSubtitle2;
